import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// const firebaseConfig = {
//   apiKey: "AIzaSyC11gPQ4PBqjHgyk3wN7b5lur0ti6Jem3M",
//   authDomain: "real-motor-workshop.firebaseapp.com",
//   projectId: "real-motor-workshop",
//   storageBucket: "real-motor-workshop.appspot.com",
//   messagingSenderId: "539165144836",
//   appId: "1:539165144836:web:1a9c267af45f8153a1c251",
//   measurementId: "G-Y7QB7W54NR"
// };

const firebaseConfig = {
  apiKey: "AIzaSyAVLtZ3e4Sg-xNNzUPofrl4DX4prz4pgH8",
  authDomain: "realmotorsindia-c8dfe.firebaseapp.com",
  projectId: "realmotorsindia-c8dfe",
  storageBucket: "realmotorsindia-c8dfe.firebasestorage.app",
  messagingSenderId: "673842831571",
  appId: "1:673842831571:web:5e2f004a1010230ec4f426"
};

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);